export default __webpack_public_path__ + "assets/no-image.70472243.svg";